var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.243 27.411",
    enableBackground: "new 0 0 31.243 27.411",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F1C233",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    d: "M22.343,21.582H8.9 c-1.46,0-2.393-1.556-1.706-2.844l6.163-11.551c0.446-0.837,1.317-1.359,2.265-1.359s1.819,0.522,2.265,1.359l6.163,11.551 C24.736,20.027,23.803,21.582,22.343,21.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#F1C233",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    d: "M16.589,10.988l-0.246,4.446 c-0.018,0.325-0.286,0.579-0.611,0.579h-0.221c-0.325,0-0.593-0.254-0.612-0.579l-0.246-4.446c-0.03-0.532,0.394-0.98,0.927-0.98 h0.081C16.195,10.008,16.619,10.455,16.589,10.988z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#F1C233",
    strokeWidth: 1.0801,
    strokeMiterlimit: 10,
    cx: 15.621,
    cy: 18.359,
    r: 0.92
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00386C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.795,0.5h8.175 c0.979,0,1.773,0.794,1.773,1.773v22.866c0,0.979-0.794,1.773-1.773,1.773h-8.175"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00386C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M10.448,26.911 H2.273c-0.979,0-1.773-0.794-1.773-1.773V2.273C0.5,1.294,1.294,0.5,2.273,0.5h8.175"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigned);
export default __webpack_public_path__ + "static/media/Assigned.cf632afbf57a9be2e066657f49eafaf2.svg";
export { ForwardRef as ReactComponent };